export default __webpack_public_path__ + "outside_fabric.png";